import fetch from 'isomorphic-fetch';
import handleAuthErrorResponse from './handleAuthError';

const API_ID_URL = process.env.REACT_APP_ID_API_URL || `https://prod-api.vmnk.in/id-service`;
// const API_ID_URL = `http://localhost:8080/id-service`;

export default function callIdApi(endpoint, method = 'get', body) {

    let token = window.sessionStorage.getItem('token') ? window.sessionStorage.getItem('token') : '';
    let xToken = window.localStorage.getItem("x-token") || ''
    let headers = {};
    headers['content-type'] = 'application/json';
    if (token && token !== '') {
        headers.Authorization = `Bearer ${token}`;
    }
    if (xToken && xToken !== '') {
        headers["x-token"] = xToken
    }
    return fetch(`${API_ID_URL}/api/${endpoint}`, {
        headers: headers,
        method,
        body: JSON.stringify(body),
    })
        .then(response => response.json().then(json => ({ json, response })))
        .then(({ json, response }) => {
            if (handleAuthErrorResponse(json)) {
                return Promise.reject(json);
            }
            if (!response.ok) {
                return Promise.reject(json);
            }
            return json;
        })
        .then(
            response => response,
            error => error
        );
}
